import { IS_STAGING } from "../constants/general";

export const generateQuickjoinLink = (id: string) =>
  `https://${IS_STAGING ? "stagingquickjoin" : "quickjoin"}.roomsync.com/?passcode=${id}`;
